
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    myApp.user.birthdate = myApp.user.birthdate === '0000-00-00' ? '' : myApp.user.birthdate; //console.log(myApp.user.birthdate);

    return {
      lng: lng,
      me: myApp.user,
      avatar: myApp.avatar()
    };
  },

  mounted() {
    //console.log('Page mounted', this.me);
    this.setBirthdate();
    const l = lng.language;
    const msg = myApp.messages[l].inserisciIlCodiceEPartecipa;
    this.$setState({
      msgConcorso: msg
    });
  },

  methods: {
    covid19() {
      const self = this,
            app = this.$app,
            $ = this.$;

      if (window.cordova) {
        const url = 'https://rest.dreamgest.com/infomycity/covid19.php?u=' + self.me.id + '&l=' + self.lng.language;
        const opt = 'location=no,toolbar=no,toolbarcolor=#ffffff,closebuttoncolor=#007aff' + ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
        const ref = cordova.InAppBrowser.open(url, '_blank', opt); // cattura evento 'close'

        ref.addEventListener('loadstart', function (event) {
          //console.log('event.url: ' + event.url);
          if (event.url.match("close")) {
            ref.close();
          }
        }); // cattura errore

        ref.addEventListener('loaderror', function (params) {
          const scriptErrorMesssage = "alert('Sorry we cannot open that page. Message from the server is : " + params.message + "');";
          ref.executeScript({
            code: scriptErrorMesssage
          }, function () {});
          ref.close();
          ref = undefined;
        }); // cattura evento di chiusura

        ref.addEventListener('exit', function () {// raggiorna user
        });
      } else {
        window.open('https://rest.dreamgest.com/infomycity/covid19.php?u=' + self.me.id + '&l=' + self.lng.language);
      }
    },

    changeLanguage() {
      const self = this,
            $ = this.$,
            app = this.$app;
      window.lng = myApp.language[$('#profileLanguage').val()];
      this.$setState({
        lng: lng
      });
      localStorage.currentLanguage = $('#profileLanguage').val();
      myApp.server.get('imc/categories/' + lng.language).then(categories => {
        myApp.categories = categories;
      });
    },

    setAvatar() {
      var self = this,
          app = this.$app,
          $ = app.$;
      var ac = app.actions.create({
        buttons: [{
          text: 'Set profile image',
          label: true
        }, {
          text: 'Camera',
          color: 'blue',
          onClick: function () {
            ac.close();

            if (app.device.cordova) {
              myApp.cordova.cameraAvatar().then(function (img) {
                $('.profile-image').css('background-image', 'url(' + img + ')');
                return myApp.server.put('imc/user_image', {
                  src: img
                });
              }).then(succ => {
                myApp.user.img_url = succ.src;
                myApp.setUser(myApp.user);
              }).catch(function (err) {
                console.log(err);
                app.toast.show({
                  text: lng.genericError,
                  closeTimeout: 3000,
                  cssClass: 'bg-color-red',
                  position: 'bottom'
                });
              });
            } else {
              /* WEB */
              let video = document.querySelector("#video-camera");
              let click_button = document.querySelector("#click-photo");
              let cancel_button = document.querySelector("#cancel-photo");
              let canvas = document.querySelector("#canvas");
              app.popup.open('.popup-camera');
              navigator.mediaDevices.getUserMedia({
                video: true,
                audio: false
              }).then(stream => {
                click_button.addEventListener('click', function () {
                  canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                  let image_data_url = canvas.toDataURL('image/jpeg');
                  self.$setState({
                    avatar: image_data_url
                  });
                  app.popup.close('.popup-camera');
                  stream.getTracks().forEach(track => track.stop());
                  return myApp.server.put('imc/user_image', {
                    src: image_data_url
                  }).then(succ => {
                    myApp.user.img_url = succ.src;
                    myApp.setUser(myApp.user);
                  }).catch(function (err) {
                    console.log(err);
                    app.toast.show({
                      text: lng.genericError,
                      closeTimeout: 3000,
                      cssClass: 'bg-color-red',
                      position: 'bottom'
                    });
                  });
                });
                cancel_button.addEventListener('click', function () {
                  stream.getTracks().forEach(track => track.stop());
                });
                video.srcObject = stream;
              });
            }
          }
        }, {
          text: 'Gallery',
          color: 'blue',
          onClick: function () {
            ac.close();

            if (app.device.cordova) {
              myApp.cordova.cameraAvatar('gallery').then(function (img) {
                $('.profile-image').css('background-image', 'url(' + img + ')');
                return myApp.server.put('imc/user_image', {
                  src: img
                });
              }).then(succ => {
                myApp.user.img_url = succ.src;
                myApp.setUser(myApp.user);
              }).catch(function (err) {
                console.log(err);
                app.toast.show({
                  text: lng.genericError,
                  closeTimeout: 3000,
                  cssClass: 'bg-color-red',
                  position: 'bottom'
                });
              });
            } else {
              /* WEB */
              var fileSelector = document.createElement('input');
              fileSelector.setAttribute('type', 'file');
              fileSelector.setAttribute('accept', 'image/*');
              fileSelector.click();

              fileSelector.onchange = () => {
                const file = fileSelector.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = () => {
                  const img = reader.result; //console.log(img);

                  myApp.server.put('imc/user_image', {
                    src: img
                  }).then(succ => {
                    console.log(succ);
                    myApp.user.img_url = succ.src;
                    myApp.setUser(myApp.user);
                    self.$setState({
                      avatar: img
                    });
                  }).catch(function (err) {
                    console.log(err);
                    app.toast.show({
                      text: lng.genericError,
                      closeTimeout: 3000,
                      cssClass: 'bg-color-red',
                      position: 'bottom'
                    });
                  });
                };
              };
            }
          }
        }, {
          text: 'Cancel',
          color: 'red'
        }]
      }).open();
    },

    save() {
      console.log('Save');
      const $ = this.$,
            app = this.$app,
            self = this,
            k = ['#profileName', '#profileLastName'];

      for (let i in k) {
        if ($(k[i]).val().length < 1 || $(k[i]).val() === '-') {
          app.toast.show({
            text: lng.errFields,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
          $(k[i]).parents('.item-input').addClass('has-error');
          return;
        } else {
          $(k[i]).parents('.item-input').removeClass('has-error');
          $(k[i]).parents('.item-input').addClass('has-success');
        }
      }

      const bd = $('#profileBirthdate').val();
      const birthday = new Date(bd);
      /*
       if (isNaN(birthday)) {
       app.toast.show({
       text: lng.errFields,
       closeTimeout: 3000,
       cssClass: 'bg-color-red',
       position: 'bottom'
       });
       $($('#profileBirthdate')).parents('.item-input').addClass('has-error');
       return;
       }
       
       const today = new Date();
       let years = (today.getFullYear() - birthday.getFullYear());
       if (today.getMonth() < birthday.getMonth() ||
       today.getMonth() == birthday.getMonth() && today.getDate() < birthday.getDate()) {
       years--;
       }
       console.log(years);
       if (years < 18) {
       app.toast.show({
       text: lng.errBirthdate,
       closeTimeout: 3000,
       cssClass: 'bg-color-red',
       position: 'bottom'
       });
       return;
       }
       */

      const sex = $('#profileSex').val();
      self.me.name = $('#profileName').val();
      self.me.lastname = $('#profileLastName').val();
      self.me.birthdate = isNaN(birthday) ? '' : $('#profileBirthdate').val();
      self.me.sex = sex == '-' ? '' : sex;
      self.me.language = $('#profileLanguage').val();
      self.me.inviteCode = $('#inviteCode').val();
      self.me.termsAndAgreementClient = $('#termsAndAgreementClient').prop('checked') ? 1 : 0;
      myApp.server.patch('imc/user', self.me).then(succ => {
        // console.log(succ);
        myApp.setUser(self.me);

        if (succ.inviteCode && !succ.inviteOk) {
          const msg = !succ.userExists ? 'Codice d\'invito non corretto' : succ.invitePresent ? 'Hai già inviato il codice d\'invito' : lng.genericError;
          app.toast.show({
            text: msg,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        } else {
          self.$router.back();
        }
      }).catch(err => {
        console.log(err);
        app.toast.show({
          text: lng.errorEnteredData,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
        return;
      });
    },

    setBirthdate() {
      var birthdate = (myApp.user.birthdate || '').split('-');
      var datePicker = this.$app.picker.create({
        inputEl: '#profileBirthdate',
        rotateEffect: true,
        value: myApp.user.birthdate ? [birthdate[0] || '1970', birthdate[1] || '01', birthdate[2] || '01'] : null,
        formatValue: function (values, displayValues) {
          return displayValues[0] + '-' + values[1] + '-' + values[2];
        },
        cols: [// Years
        {
          values: function () {
            var year = new Date().getFullYear();
            var arr = [lng.year];

            for (var i = 1920; i <= year; i++) {
              arr.push(i);
            }

            return arr;
          }()
        }, // Months
        {
          values: (lng.month + ' 01 02 03 04 05 06 07 08 09 10 11 12').split(' '),
          textAlign: 'center'
        }, // Days
        {
          values: (lng.day + ' 01 02 03 04 05 06 07 08 09 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31').split(' '),
          textAlign: 'center'
        }]
      });
    }

  },
  id: '42d885b2a6',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">';
      r += c(ctx_1.lng.cancel, ctx_1);
      r += '</span>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.lng.profile, ctx_1);
      r += '</div>\n        <div class="right">\n          <button @click="save" \n                   class="button button-fill button-round bg-color-imc text-color-primary">\n            ';
      r += c(ctx_1.lng.save, ctx_1);
      r += '\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class="page-content bg-color-white">\n      <div style="height: 20px"></div>\n      <center>\n        <div @click="setAvatar" class="profile-image" style="background-image:url(';
      r += c(ctx_1.avatar, ctx_1);
      r += ')"></div>\n      </center>\n      <form action="javascript:;">\n        <div class="list">\n          <ul>\n            <li class="item-content item-input">\n              <div class="item-inner">\n                <div class="item-title item-label">';
      r += c(ctx_1.lng.languageLabel, ctx_1);
      r += '</div>\n                <div class="item-input-wrap">\n                  <select id="profileLanguage" @change="changeLanguage">\n                    <option ';
      r += Template7Helpers.js_if.call(ctx_1, "this.lng.language=='en'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'selected';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' value="en">English</option>\n                    <option ';
      r += Template7Helpers.js_if.call(ctx_1, "this.lng.language=='fr'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'selected';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' value="fr">Français</option>\n                    <option ';
      r += Template7Helpers.js_if.call(ctx_1, "this.lng.language=='it'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'selected';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' value="it">Italiano</option>\n                  </select>\n                </div>\n              </div>\n            </li>\n            <li class="item-content item-input">\n              <div class="item-inner">\n                <div class="item-title item-label">';
      r += c(ctx_1.lng.yourFirstName, ctx_1);
      r += '</div>\n                <div class="item-input-wrap">\n                  <input type="text" name="name" id="profileName" \n                         value="';
      r += c(ctx_1.me.name, ctx_1);
      r += '"\n                         required validate\n                         placeholder="';
      r += c(ctx_1.lng.yourFirstName, ctx_1);
      r += '">\n                  <span class="input-clear-button"></span>\n                </div>\n              </div>\n            </li>\n            <li class="item-content item-input">\n              <div class="item-inner">\n                <div class="item-title item-label">';
      r += c(ctx_1.lng.yourLastName, ctx_1);
      r += '</div>\n                <div class="item-input-wrap">\n                  <input type="text" name="lastname" id="profileLastName" \n                         value="';
      r += c(ctx_1.me.lastname, ctx_1);
      r += '"\n                         required validate\n                         placeholder="';
      r += c(ctx_1.lng.yourLastName, ctx_1);
      r += '">\n                  <span class="input-clear-button"></span>\n                </div>\n              </div>\n            </li>\n            <li class="item-content item-input">\n              <div class="item-inner">\n                <div class="item-title item-label">';
      r += c(ctx_1.lng.gender.title, ctx_1);
      r += '</div>\n                <div class="item-input-wrap input-dropdown-wrap">\n                  <select id="profileSex">\n                    <option value="-">';
      r += c(ctx_1.lng.select, ctx_1);
      r += '</option>\n                    <option ';
      r += Template7Helpers.js_if.call(ctx_1, "this.me.sex == 'm'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'selected';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n                            value="m">';
      r += c(ctx_1.lng.gender.male, ctx_1);
      r += '</option>\n                    <option ';
      r += Template7Helpers.js_if.call(ctx_1, "this.me.sex == 'f'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'selected';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n                            value="f">';
      r += c(ctx_1.lng.gender.female, ctx_1);
      r += '</option>\n                  </select>\n                </div>\n              </div>\n            </li>\n            <li class="item-content item-input">\n              <div class="item-inner">\n                <div class="item-title item-label">';
      r += c(ctx_1.lng.birthDate, ctx_1);
      r += '</div>\n                <div class="item-input-wrap">\n                  <input id="profileBirthdate" type="text" readonly="readonly" value="';
      r += c(ctx_1.me.birthdate, ctx_1);
      r += '" placeholder="';
      r += c(ctx_1.lng.select, ctx_1);
      r += '">\n                </div>\n              </div>\n            </li>\n            <li class="item-content">\n              <div class="item-inner">\n                <div class="item-title">';
      r += c(ctx_1.lng.iAgree, ctx_1);
      r += ' <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/termsAndAgreementClient.pdf">';
      r += c(ctx_1.lng.termsAndAgreement, ctx_1);
      r += '</a></div>\n                <div class="item-after">\n                  <label class="toggle">\n                    <input id="termsAndAgreementClient" ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.me.termsAndAgreementClient, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' type="checkbox">\n                    <span class="toggle-icon"></span>\n                  </label>\n                </div>\n              </div>\n            </li>\n            <p class="padding-horizontal msgConcorso">';
      r += c(ctx_1.msgConcorso, ctx_1);
      r += '</p>\n            <li class="item-content item-input">\n              <div class="item-inner">\n                <div class="item-title item-label"></div>\n                <div class="item-input-wrap">\n                  <input id="inviteCode" type="text"  placeholder="';
      r += c(ctx_1.lng.insertInviteCode, ctx_1);
      r += '">\n                  <span class="input-clear-button"></span>\n                </div>\n              </div>\n            </li>\n          </ul>\n        </div>\n      </form>\n      <!-- <div class="block">\n        <button class="button button-fill button-round bg-color-primary text-color-imc" @click="covid19">';
      r += c(ctx_1.lng.COVID_19_MODULE, ctx_1);
      r += '</button>\n      </div> -->\n    </div>\n    <div class="popup popup-camera theme-dark">\n\n      <div id="camera-container">\n        <video id="video-camera" width="320" height="240" playsinline webkit-playsinline autoplay></video>\n\n        <div class="row block">\n          <div class="col">\n            <button id="click-photo" class="button button-fill button-round button-large color-green">Take a photo</button>\n          </div>\n          <div class="col">\n            <button id="cancel-photo" data-popup=".popup-camera"\n                    class="button button-fill button-round button-large bg-color-red text-color-white popup-close">Cancel</button>\n          </div>\n        </div>\n\n        <canvas id="canvas" class="hidden" width="320" height="240"></canvas>\n      </div>\n\n\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    